(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-gender-toolbar"] && !Shopify.designMode) return;
  try {
    
  class GenderSortToolbar extends HTMLElement {
    connectedCallback() {
      // The size dropdown holds the selected size; the desktop size tabs mirror it
      this.sizeSelect = this.querySelector('[data-size]');
      this.sizeList = this.querySelector('[data-size-list]');
      this.sortSelect = this.querySelector('[data-sort]');
      this.empty = this.querySelector('[data-empty]');
      this.addEventListener('change', this.#onChange);
      this.addEventListener('click', this.#onClick);

      // ?gender=women opens the page on Women, e.g. from a menu link
      const gender = new URLSearchParams(window.location.search).get('gender');
      const option = gender && this.querySelector(`input[type="radio"][value="${CSS.escape(gender)}"]`);
      if (option instanceof HTMLInputElement) option.checked = true;

      this.#updateSizeOptions(false);
      this.#applySizeFilter();
      // The browser may restore a previous sort choice on back navigation
      if (this.sortSelect && this.sortSelect.value !== 'featured') this.#sort();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.#onChange);
      this.removeEventListener('click', this.#onClick);
    }

    /** Size tab click: select it, or clear it when it's already selected. */
    /** @param {MouseEvent} event */
    #onClick = (event) => {
      const button = event.target instanceof Element ? event.target.closest('.gender-toolbar__size') : null;
      if (!(button instanceof HTMLButtonElement) || !(this.sizeSelect instanceof HTMLSelectElement)) return;

      const size = button.dataset.size ?? '';
      this.sizeSelect.value = this.sizeSelect.value === size ? '' : size;
      this.#syncSizeButtons();
      this.#applySizeFilter();
    };

    #syncSizeButtons() {
      const selected = this.sizeSelect instanceof HTMLSelectElement ? this.sizeSelect.value : '';
      for (const button of this.sizeList?.querySelectorAll('.gender-toolbar__size') ?? []) {
        button.setAttribute('aria-pressed', String(button.getAttribute('data-size') === selected));
      }
    }

    get #gender() {
      const checked = this.querySelector('input[type="radio"]:checked');
      return checked instanceof HTMLInputElement ? checked.value : '';
    }

    get #items() {
      return /** @type {HTMLElement[]} */ ([...document.querySelectorAll('.product-grid__item[data-sizes]')]);
    }

    /** @param {Event} event */
    #onChange = (event) => {
      const target = event.target;
      if (target instanceof HTMLInputElement && target.type === 'radio') {
        // A new gender starts with no size selected
        this.#updateSizeOptions(true);
        this.#applySizeFilter();
      } else if (target === this.sizeSelect) {
        this.#syncSizeButtons();
        this.#applySizeFilter();
      } else if (target === this.sortSelect) {
        this.#sort();
      }
    };

    /** Fills the size list with the in-stock sizes of the selected gender. */
    #updateSizeOptions(reset) {
      const select = this.sizeSelect;
      if (!(select instanceof HTMLSelectElement)) return;

      const gender = this.#gender;
      const sizes = new Set();
      for (const item of this.#items) {
        if (item.dataset.gender && item.dataset.gender !== gender) continue;
        for (const size of (item.dataset.sizes ?? '').split('|')) if (size) sizes.add(size);
      }

      const number = (value) => parseFloat(value.replace(/[^\d.]/g, '')) || 0;
      const sorted = [...sizes].sort((a, b) => number(a) - number(b) || a.localeCompare(b));
      const previous = reset ? '' : select.value;
      const placeholder = select.options[0];

      select.replaceChildren(placeholder, ...sorted.map((size) => new Option(size, size)));
      select.value = sorted.includes(previous) ? previous : '';

      if (this.sizeList) {
        this.sizeList.replaceChildren(
          ...sorted.map((size) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'gender-toolbar__size';
            button.dataset.size = size;
            button.textContent = size;
            return button;
          })
        );
        this.#syncSizeButtons();
      }
    }

    #applySizeFilter() {
      const size = this.sizeSelect instanceof HTMLSelectElement ? this.sizeSelect.value : '';
      const gender = this.#gender;
      let visible = 0;

      for (const item of this.#items) {
        const hidden = size !== '' && !(item.dataset.sizes ?? '').includes(`|${size}|`);
        item.classList.toggle('is-size-hidden', hidden);
        if (!hidden && (!item.dataset.gender || item.dataset.gender === gender)) visible++;
      }

      if (this.empty) this.empty.hidden = visible > 0;
    }

    #sort() {
      const value = this.sortSelect instanceof HTMLSelectElement ? this.sortSelect.value : 'featured';
      const lists = new Map();

      for (const item of this.#items) {
        if (!item.parentElement) continue;
        if (!lists.has(item.parentElement)) lists.set(item.parentElement, []);
        lists.get(item.parentElement).push(item);
      }

      const position = (item) => Number(item.dataset.index);
      const price = (item) => Number(item.dataset.price);

      for (const [list, listItems] of lists) {
        listItems.sort((a, b) => {
          if (value === 'price-ascending') return price(a) - price(b) || position(a) - position(b);
          if (value === 'price-descending') return price(b) - price(a) || position(a) - position(b);
          return position(a) - position(b);
        });
        list.append(...listItems);
      }
    }
  }

  if (!customElements.get('gender-sort-toolbar')) {
    customElements.define('gender-sort-toolbar', GenderSortToolbar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
